<template>
  <div class="col-9 py-3 px-4 h-100 overflow-auto">
    <h6 v-t="'auth.roleEdit.authority'" />
    <div v-for="(feature, index) in features" :key="index" class="border border-light rounded my-3 p-3">
      <div class="d-flex align-items-center justify-content-between">
        <div class="d-flex align-items-center flex-grow-1">
          <h6 v-t="`features.${feature.id}`" class="m-0 text-nowrap" />
          <!-- <p v-t="`features.${feature.id}_Desc`" class="mb-0 mx-2 font-size-sm text-gray600 text-truncate text-truncate-1" /> -->
        </div>
        <b-form-checkbox v-model="feature.enabled" name="check-button" switch />
      </div>
      <b-collapse v-model="feature.enabled">
        <p class="mb-0 mx-2 font-size-sm text-gray600">
          <b>{{ $t('auth.roleEdit.permissionDesc.edit.label') }}</b>{{ $t('auth.roleEdit.permissionDesc.edit.desc') }}
          <b>{{ $t('auth.roleEdit.permissionDesc.publish.label') }}</b>{{ $t('auth.roleEdit.permissionDesc.publish.desc') }}<br>
          <b>{{ $t('auth.roleEdit.permissionDesc.viewType.label') }}</b>{{ $t('auth.roleEdit.permissionDesc.viewType.desc') }}
        </p>
        <b-table
          :fields="fields"
          :items="feature.subFeatures.filter((item) => !item.virtual)"
          class="font-size-md text-nowrap mb-n3 mt-3"
          head-variant="light"
          thead-class="text-nowrap"
          tbody-tr-class="position-relative"
          hover
          sticky-header
          responsive
        >
          <template v-slot:head(enabled)>
            <b-form-checkbox :checked="feature.isCheckedAll" :indeterminate.sync="feature.isIndeterminate" @change="checkAll(feature, $event)" />
          </template>
          <template v-slot:cell(enabled)="{ item }">
            <b-form-checkbox v-model="item.enabled" @change="checkFeature(item, $event)" />
          </template>
          <template v-slot:cell(id)="item">
            {{ $t(`features.${item.value}`) }}
          </template>
          <template v-slot:cell(viewType)="{ item }">
            <b-input-group-prepend>
              <b-form-select
                v-model="item.viewType"
                :options="viewTypeOptions"
                size="sm"
                class="rounded-pill"
              />
            </b-input-group-prepend>
          </template>
          <template v-slot:cell(permission.edit)="{ item }">
            <b-form-checkbox v-if="item.permission.edit" v-model="item.permission.edit.enabled" @change="checkPermission(item, $event)" />
          </template>
          <template v-slot:cell(permission.publish)="{ item }">
            <b-form-checkbox v-if="item.permission.publish" v-model="item.permission.publish.enabled" @change="checkPermission(item, $event)" />
          </template>
          <template v-slot:cell(permission.delete)="{ item }">
            <b-form-checkbox v-if="item.permission.delete" v-model="item.permission.delete.enabled" @change="checkPermission(item, $event)" />
          </template>
          <template v-slot:cell(permission.export)="{ item }">
            <b-form-checkbox v-if="item.permission.export" v-model="item.permission.export.enabled" @change="checkPermission(item, $event)" />
          </template>
          <template v-slot:cell(permission.import)="{ item }">
            <b-form-checkbox v-if="item.permission.import" v-model="item.permission.import.enabled" @change="checkPermission(item, $event)" />
          </template>
          <template v-slot:cell(permission.reject)="{ item }">
            <b-form-checkbox v-if="item.permission.reject" v-model="item.permission.reject.enabled" @change="checkPermission(item, $event)" />
          </template>
        </b-table>
      </b-collapse>
    </div>
  </div>
</template>

<script>
// import {
//   DefaultMenu,
//   MenuItem
// } from '@/objects/FeaturesSetting.js';
import PermissionService from '@/services/PermissionService';

export default {
  props: ['roleId', 'value'],
  data() {
    return {
      allFeatures: undefined,
      enabledFeatures: this.value || [],
      features: [],
      viewTypeOptions: [
        { value: 0, text: this.$t('auth.roleEdit.viewType.option.nolimit') },
        { value: 1, text: this.$t('auth.roleEdit.viewType.option.sameRole') }
      ],
      fields: [
        {
          key: 'enabled', label: '', class: 'align-middle text-center', thClass: 'border-0', thAttr: { width: '5%' },
        },
        {
          key: 'id', label: this.$t('auth.roleEdit.feature'), class: 'align-middle', thClass: 'border-0', thAttr: { width: '25%' },
        },
        {
          key: 'viewType', label: this.$t('auth.roleEdit.viewType.label'), class: 'align-middle', thClass: 'border-0', thAttr: { width: '20%' },
        },
        {
          key: 'permission.edit', label: this.$t('auth.roleEdit.permission.edit'), class: 'align-middle text-center', thClass: 'border-0'
        },
        {
          key: 'permission.publish', label: this.$t('auth.roleEdit.permission.publish'), class: 'align-middle text-center', thClass: 'border-0'
        },
        {
          key: 'permission.delete', label: this.$t('auth.roleEdit.permission.delete'), class: 'align-middle text-center', thClass: 'border-0'
        },
        {
          key: 'permission.export', label: this.$t('auth.roleEdit.permission.export'), class: 'align-middle text-center', thClass: 'border-0'
        },
        {
          key: 'permission.import', label: this.$t('auth.roleEdit.permission.import'), class: 'align-middle text-center', thClass: 'border-0'
        },
        {
          key: 'permission.reject', label: this.$t('auth.roleEdit.permission.reject'), class: 'align-middle text-center', thClass: 'border-0'
        }
      ],
      // permissionField: {
      //   edit:
      //   {
      //     key: 'permission.edit', label: this.$t('auth.roleEdit.permission.edit'), class: 'align-middle text-center', thClass: 'border-0'
      //   },
      //   publish:
      //   {
      //     key: 'permission.publish', label: this.$t('auth.roleEdit.permission.publish'), class: 'align-middle text-center', thClass: 'border-0'
      //   },
      //   delete:
      //   {
      //     key: 'permission.delete', label: this.$t('auth.roleEdit.permission.delete'), class: 'align-middle text-center', thClass: 'border-0'
      //   },
      //   export:
      //   {
      //     key: 'permission.export', label: this.$t('auth.roleEdit.permission.export'), class: 'align-middle text-center', thClass: 'border-0'
      //   },
      //   import:
      //   {
      //     key: 'permission.import', label: this.$t('auth.roleEdit.permission.import'), class: 'align-middle text-center', thClass: 'border-0'
      //   },
      //   reject:
      //   {
      //     key: 'permission.reject', label: this.$t('auth.roleEdit.permission.reject'), class: 'align-middle text-center', thClass: 'border-0'
      //   }
      // }
    };
  },
  watch: {
    value(val) {
      this.enabledFeatures = val;
    },
    features: {
      handler(val) {
        const features = this.toFeatureModel(val);
        this.$emit('input', features);
      },
      deep: true
    }
  },
  async created() {
    // 取得功能資料
    await this.LoadFeaturesAsync();
    // 初始化權限設定資料
    this.initFeatures();
  },
  methods: {
    // 取得功能資料
    async LoadFeaturesAsync() {
      await this.$loading(async () => {
        await Promise.all([
          this.LoadCompanyFeaturesAsync(),
          this.LoadRoleFeaturesAsync()
        ]);
      });
    },
    // 取得公司所有功能資料
    async LoadCompanyFeaturesAsync() {
      const allFeatures = await PermissionService.GetCompanyFeaturesAsync();
      // const validFeatures = MenuItem.GetEnabledFeatures(allFeatures, DefaultMenu);
      this.allFeatures = allFeatures;
    },
    // 取得角色已開啟功能資料
    async LoadRoleFeaturesAsync() {
      if ((this.value || null) === null && (this.roleId || '') !== '') {
        const enabledFeatures = await PermissionService.GetRoleFeaturesAsync(this.roleId);
        this.enabledFeatures = enabledFeatures;
      } else {
        this.enabledFeatures = [];
      }
    },
    // 初始化權限設定資料
    initFeatures() {
      const vm = this;
      vm.features = vm.allFeatures.map((feature) => {
        const model = {
          id: feature.id,
          // 子功能是否半勾選
          get isIndeterminate() {
            const validFeatures = this.subFeatures.filter((item) => !item.virtual);
            // 勾選的項目
            const checkedFeatureCount = validFeatures.filter((item) => item.enabled).length;
            return checkedFeatureCount < validFeatures.length && checkedFeatureCount > 0;
          },
          // 子功能是否全部勾選
          get isCheckedAll() {
            return this.subFeatures.filter((item) => !item.virtual && !item.enabled).length === 0;
          }
        };

        const enabledFeature = vm.enabledFeatures.find((v) => v.id === feature.id);

        model.enabled = !!enabledFeature;

        // 判斷是否有子功能
        if (feature.children.length > 0) {
          // 主功能為虛擬功能
          model.subFeatures = [
            {
              id: feature.id, main: true, virtual: true, viewType: 0
            },
            ...this.initSubFeatures(feature, enabledFeature, [])
          ];
        } else {
          // 僅處理主功能
          model.subFeatures = [
            {
              id: feature.id, main: true, virtual: false, enabled: model.enabled, viewType: enabledFeature?.viewType || 0, permission: this.getPermission(feature, enabledFeature)
            }
          ];
        }

        return model;
      });
    },
    // 初始化子功能設置
    initSubFeatures(feature, enabledFeature) {
      let features = [];

      feature.children.forEach((sub) => {
        const target = enabledFeature?.children.find((item) => item.id === sub.id);

        // 判斷是否有子功能
        if (sub.children.length > 0) {
          // 虛擬功能
          features.push({
            id: sub.id, parentId: feature.id, virtual: true, viewType: 0
          });

          features = features.concat(this.initSubFeatures(sub, target));
        } else {
          features.push({
            id: sub.id, parentId: feature.id, enabled: !!target, viewType: target?.viewType || 0, permission: this.getPermission(sub, target), virtual: false
          });
        }
      });

      return features;
    },
    // 取得操作權限設置
    getPermission(feature, enabledFeature) {
      const origin = feature ? feature.permissions || [] : [];
      const target = enabledFeature ? enabledFeature.permissions || [] : [];
      const permission = {};

      origin.forEach((item) => {
        permission[item] = { enabled: target.includes(item) };
      });

      return permission;
    },
    // 勾選全部選項
    checkAll(feature, status) {
      feature.subFeatures.forEach((item) => {
        const obj = item;
        if (!obj.virtual) {
          obj.enabled = status;
          // 勾選操作權限
          this.checkFeature(obj, status);
        }
      });
    },
    // 勾選功能
    checkFeature(feature, status) {
      Object.keys(feature.permission).forEach((key) => {
        // eslint-disable-next-line no-param-reassign
        feature.permission[key].enabled = status;
      });
    },
    // 勾選操作權限
    checkPermission(feature, status) {
      if (status) {
        // eslint-disable-next-line no-param-reassign
        feature.enabled = status;
      }
    },
    // 轉為階層功能
    toFeatureModel(features) {
      return features.filter((item) => item.enabled && item.subFeatures.filter((sub) => sub.enabled).length > 0)
        .map((item) => {
          // 主功能
          const main = item.subFeatures.find((sub) => sub.main);
          const feature = {
            id: main.id, viewType: main.viewType, permissions: this.getEnabledPermission(main.permission), children: []
          };

          feature.children = this.getSubFeatures(feature.id, item.subFeatures);

          return feature;
        });
    },
    // 取得子功能
    getSubFeatures(parentId, features) {
      const subFeatures = features.filter((item) => item.parentId === parentId && (item.enabled || item.virtual))
        .map((item) => ({
          id: item.id,
          virtual: item.virtual,
          viewType: item.viewType,
          children: this.getSubFeatures(item.id, features),
          permissions: this.getEnabledPermission(item.permission)
        }))
        // 移除無子功能的虛擬功能
        .filter((sub) => !sub.virtual || (sub.children.length > 0));

      return subFeatures;
    },
    // 取得啟用的操作權限
    getEnabledPermission(permission) {
      if (!permission) {
        return null;
      }
      return Object.keys(permission).filter((key) => permission[key].enabled).map((key) => key);
    },
    // // 取得有效操作權限
    // getPermissionFields(features) {
    //   const permissions = [...new Set(features.reduce((accum, current) => {
    //     if (current.permission) {
    //       // eslint-disable-next-line no-param-reassign
    //       accum = accum.concat(Object.keys(current.permission));
    //     }
    //     return accum;
    //   }, []))];

    //   const permissionFields = permissions.map((permission) => this.permissionField[permission]);

    //   return this.fields.concat(permissionFields);
    // }
  }
};
</script>
